import template from './index.jst';
import { View } from "backbone.marionette";
import { Model } from 'backbone';

export default class CoachHeaderView extends View {
	get template() {
		return template;
	}

	get tagName() {
		return 'h2';
	}

	initialize() {
		this.model = new Model( {
			message: ''
		} );
	}

	init( message ) {
		this.model.set( { message } );

		this.render();
	}
}